import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";
// import Add from "./Add";
// import Edit from "./Edit";
import Delete_Points_Modal from "../../Common_Component/Common_Modal/Delete_Points_Modal/Delete_Points_Modal";
import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  findAllHistory,
  Status,
} from "../../../utils/apis/wallet_management/wallet_hisory/wallet_history";

import { Per_Page_Dropdown, users_type } from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import {
  AllGames,
  AllRoles,
  AllWalletType,
  Country,
  State,
} from "../../../utils/apis/common/index";
import { formatDate } from "../../../utils/common";
import Select from "react-select";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
const Tables = () => {
  const { id } = Object.fromEntries(
    new URLSearchParams(window.location.search),
  );

  const location = useLocation();

  const name = location.state?.name;
  const queryWalletType = location.state?.name;

  const { UnauthorizedLogOut, Select2Data, IMG_URL, usertype } =
    useContext(Context);

  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(10);
  const [gameSearch, setGameSearch] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const statusFromUrl = searchParams.get("wallet_type");
  const [walletTypeSearch, setWalletTypeSearch] = useState(statusFromUrl || "");

  const statusFromRoleUrl = searchParams.get("role_type");
  const [roleTypeSearch, setRoleTypeSearch] = useState(statusFromRoleUrl || "");
  const statusTypeUrl = searchParams.get("type");
  const [creditDebitSearch, setCreditDebitSearch] = useState(
    statusTypeUrl || "",
  );

  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const statusToDateUrl = searchParams.get("date");
  const [searchDateTo, setSearchDateTo] = useState(statusToDateUrl || "");

  const statusFromDateUrl = searchParams.get("date");

  const [search, setSearch] = useState(name);

  const [searchDateFrom, setSearchDatefrom] = useState(statusFromDateUrl || "");
  const handleAccept = async (data) => {
    try {
      const response = await Status(data.id, { status: 1 });
      await setData(response?.data);
      setCurrentPage(response?.data?.data?.current_page);
      setperPage(response?.data?.data?.per_page);
      // setSearch(response?.data?.data?.search_name);

      setOption(await Per_Page_Dropdown(response?.data?.data?.total));
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  const [games, setGames] = useState([]);
  const [walletType, setWalletType] = useState([]);
  const [roleType, setRoleType] = useState([]);

  const getDataAll = async () => {
    setLoading(true);

    try {
      const response = await findAllHistory(
        currentPage,
        perPage,
        search,
        gameSearch,
        walletTypeSearch,
        roleTypeSearch,
        searchDateFrom,
        searchDateTo,
        creditDebitSearch,
        id,
      );

      await setData(response?.data);
      setCurrentPage(response?.data?.data?.current_page);
      setperPage(response?.data?.data?.per_page);
      // setSearch(response?.data?.data?.search_name);

      setOption(await Per_Page_Dropdown(response?.data?.data?.total));

      if (response?.data?.success) {
        setLoading(false);
      }
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [
    changeStatus,
    perPage,
    reset,
    modalShow,
    modalEditShow,
    currentPage,
    walletTypeSearch,
    gameSearch,
    creditDebitSearch,
    // search,
  ]);

  // const StatusChange = async (id) => {
  //   const response = await Status(id);
  //   setChangeStatus(response);
  // };

  // const handleDeleteRecord = async () => {
  //   setModalDeleteShow(false);
  //   if (recordToDeleteId) {
  //     const response = await Delete(recordToDeleteId);
  //     setRecordToDeleteId(null);
  //     setChangeStatus(response);
  //   }
  // };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleDateChange = (date) => {
    setSearchDateTo(date); // Update the state with the selected date
  };

  const GetAllGames = async () => {
    const response = await AllGames();
    if (response?.data?.success) {
      setGames(await Select2Data(response?.data?.data, "game_id"));
    }
  };

  const GetAllWalletTypes = async () => {
    const response = await AllWalletType();
    if (response?.data?.success) {
      setWalletType(await Select2Data(response?.data?.data, "game_id"));
    }
  };

  const GetAllRoles = async () => {
    const response = await AllRoles();
    if (response?.data?.success) {
      setRoleType(await Select2Data(response?.data?.data, "role_id"));
    }
  };

  useEffect(() => {
    GetAllGames();
    GetAllWalletTypes();
    GetAllRoles();
  }, []);

  const creditDebitOptions = [
    { label: "Credit", value: "Credit" },
    { label: "Debit", value: "Debit" },
  ];

  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"Wallet History"} />
        <div className="search-bar-holder ">
          <Form>
            <div className="row align-items-end">
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <br />
                  <Select
                    options={games}
                    value={games.find((g) => g.value === gameSearch) || null}
                    onChange={(selectedOption) => {
                      setGameSearch(selectedOption?.value || "");
                    }}
                    placeholder="Select Game"
                  />
                </Form.Group>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
                <Form.Group className="form-field" controlId="formBasicEmail">
                  <br></br>
                  <Form.Control
                    type="text"
                    placeholder="User Name"
                    onChange={(e) => setSearch(e.target?.value)}
                    value={search}
                    className="mt-1"
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <br />
                  <Select
                    options={creditDebitOptions}
                    value={
                      creditDebitOptions.find(
                        (g) => g.value === creditDebitSearch,
                      ) || null
                    }
                    onChange={(selectedOption) => {
                      setCreditDebitSearch(selectedOption?.value || "");
                    }}
                    placeholder="Select Credit / Debit"
                    isClearable
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <br />
                  <Select
                    options={walletType}
                    value={
                      walletType.find((g) => g.value === walletTypeSearch) ||
                      null
                    }
                    onChange={(selectedOption) => {
                      setWalletTypeSearch(selectedOption?.value || "");
                    }}
                    placeholder="Select Wallet Type"
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <br />
                  <Select
                    options={roleType}
                    value={
                      roleType.find((g) => g.value === roleTypeSearch) || null
                    }
                    onChange={(selectedOption) => {
                      setRoleTypeSearch(selectedOption?.value || "");
                    }}
                    placeholder="Select User Role"
                  />
                </Form.Group>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
                <Form.Group className="form-field" controlId="formBasicEmail">
                  <Form.Label className="formlbb">From</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="From"
                    max="9999-12-31"
                    min="0001-01-01"
                    value={searchDateFrom}
                    onChange={(e) => {
                      const value = e.target?.value;

                      // extra safety (optional)
                      const year = value.split("-")[0];
                      if (year.length !== 4) return;

                      setSearchDatefrom(value);
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
                <Form.Group className="form-field" controlId="formBasicEmail">
                  <Form.Label className="formlbb">To</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="to"
                    min={searchDateFrom} // already good
                    max="9999-12-31" // ✅ restrict year to 4 digits
                    value={searchDateTo}
                    onChange={(e) => {
                      const value = e.target?.value;

                      // basic format safety
                      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return;

                      const year = value.split("-")[0];
                      if (year.length !== 4) return;

                      handleDateChange(value);
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5  col-holder">
                <br></br>
                <Button
                  type="button"
                  className="search-btn mt-2"
                  onClick={getDataAll}>
                  Search
                </Button>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5   col-holder">
                <br></br>
                <Button
                  type="button"
                  className="reset-btn mt-2"
                  onClick={() => {
                    setSearch("");
                    setSearchDateTo("");
                    setGameSearch("");
                    setSearchDatefrom("");
                    setWalletTypeSearch("");
                    setRoleTypeSearch("");
                    setCreditDebitSearch("");
                    setReset(!reset);
                  }}>
                  Reset
                </Button>
              </div>
              {/* <div className=" col-12 mt-3">
                <div className="d-flex  align-items-center">
                  <div className="show me-2">
                    <p style={{ color: "white" }} className="show m-0">
                      Show
                    </p>
                  </div>
                  <div className="number me-2">
                    <select
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                      onChange={(e) => setperPage(e.target?.value)}
                    >
                      {option?.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="entries">
                    <p style={{ color: "white" }} className="show m-0">
                      entries
                    </p>
                  </div>

                  <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-6 col-sm-2 col-12">
                    <div className="sowing me-2 ms-5">
                      <p
                        style={{ color: "white" }}
                        className="show m-0"
                      >{`Showing ${Math.min(
                        (currentPage - 1) * perPage + 1
                      )} to ${Math.min(
                        currentPage * perPage,
                        data?.data?.total
                      )} of ${data?.data?.total} entries`}</p>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </Form>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="user-list-table">
              {/* <Banner_List_Table /> */}

              <div className="data-table-holder">
                <Table responsive bordered striped>
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Game</th>
                      <th>Deposit Type</th>
                      <th>User Name</th>
                      <th>User Role</th>
                      <th>Handle By</th>
                      <th>Email</th>
                      <th>Type</th>
                      <th>Wallet Type</th>
                      <th>Payment Id</th>
                      <th>Remark</th>
                      <th>Points</th>
                      <th>Payment Status</th>
                      <th>Date</th>
                      <th>Time</th>
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="9" className="text-center py-4">
                          <div
                            className="spinner-border text-primary"
                            role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : data?.data?.data?.length > 0 ? (
                      data.data.data.map((d, index) => {
                        return (
                          <tr key={d.id || index}>
                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                            <td>{d?.Game?.name || "-"}</td>
                            <td>{d?.PaymentMethod?.name || "-"}</td>
                            <td>{d?.User?.name || "-"}</td>
                            <td>{d?.User?.Role?.name || "-"}</td>
                            <td>{d?.withdraw_accept?.name || "-"}</td>
                            <td>{d?.User?.email || "-"}</td>
                            <td>
                              <span
                                className={
                                  d?.type == "Credit"
                                    ? "CraditText"
                                    : "DebitText"
                                }>
                                {d?.type}
                              </span>
                            </td>
                            <td>
                              <span
                                className={
                                  d?.wallet_type_id == 1
                                    ? "WithdrawalText"
                                    : d?.wallet_type_id == 2
                                      ? "CommissionText"
                                      : d?.wallet_type_id == 3
                                        ? "DepositText"
                                        : d?.wallet_type_id == 4
                                          ? "BetText"
                                          : d?.wallet_type_id == 5
                                            ? "WinText"
                                            : "RummyGameText"
                                }>
                                {" "}
                                {d?.Wallet_Type?.name}
                              </span>
                            </td>
                            <td>{d?.payment_id || "-"}</td>
                            <td>{d?.remark}</td>
                            <td>
                              <span
                                className={
                                  d?.type == "Credit" &&
                                  d.request_status_id == 2
                                    ? "CraditText"
                                    : "DebitText"
                                }>
                                {d?.amount} points
                              </span>
                            </td>{" "}
                            <td>
                              <span
                                className={
                                  d.request_status_id == 2
                                    ? "CraditText"
                                    : d.request_status_id == 3
                                      ? "DebitText"
                                      : "ProcessText"
                                }>
                                {d?.RequestStatus?.name}
                              </span>
                            </td>
                            <td>{d?.createdAt?.split("T")[0]}</td>
                            <td>
                              {new Date(d.createdAt).toLocaleString("en-GB", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                            </td>{" "}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>

                <CustomPaginate
                  currentPage={data?.data?.current_page}
                  totalPages={data?.data?.total_pages}
                  handlePageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Tables;
